'use strict';

var userAgent = require('../../useragent');
var events = require('../../events');
var prefixedCookies = require('../../cookies')('_hcfnl_');
var gecko = require('./gecko');
var trident = require('./trident');
var webkit = require('./webkit');

var incognito = prefixedCookies.get('incognito');
switch (incognito) {
  case '1': incognito = true; break;
  case '0': incognito = false; break;
  default: incognito = null; break;
}

var setter = function(value) {
  incognito = value;
  prefixedCookies.set('incognito', value ? '1' : '0');
};

if (incognito === null) {
  if (userAgent.webkit()) {
    webkit(setter);
  } else if (userAgent.gecko()) {
    gecko(setter);
  } else if (userAgent.trident()) {
    trident(setter);
  }
}

module.exports = function() {
  return incognito;
};



//////////////////
// WEBPACK FOOTER
// ./lib/funnel/incognito/index.js
// module id = 18
// module chunks = 1 3